import { isEmpty } from 'lodash-es';
import type { AnyAction } from 'redux';
import { REHYDRATE } from 'redux-persist';
import { put, select, take } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { actions as messagesActions } from '@/modules/messages';

import { SECRETS_CACHE } from '../../constants';
import { activateSyncSecrets, loadSecrets, loadSecretsFailure, loadSecretsSuccess, setSecrets, syncSecrets } from '../actions';
import { normalizeSecrets } from '../normalizers';
import { selectMappedSecrets, selectSecretsEntities } from '../selectors';
import fetchSecrets from './fetchSecrets';

export default function* () {
    try {
        yield put(loadSecrets());

        const entities: ReturnType<typeof selectSecretsEntities> = yield select(selectSecretsEntities);

        if (!entities.list._persist.rehydrated) {
            yield take((action: AnyAction) => action.type === REHYDRATE && action.key === SECRETS_CACHE);
        }

        const mappedSecrets: ReturnType<typeof selectMappedSecrets> = yield select(selectMappedSecrets);
        const emptySecrets = isEmpty(mappedSecrets);

        if (emptySecrets) {
            const data = yield* fetchSecrets();

            const { entities, result } = normalizeSecrets(data);

            yield put(setSecrets(entities.secrets, result));
        }

        yield put(loadSecretsSuccess());

        yield put(activateSyncSecrets());

        if (!emptySecrets) {
            const verbose = true;
            yield put(syncSecrets(verbose));
        }
    } catch (e) {
        yield put(
            messagesActions.displayErrorMessage({
                message: { id: 'error.secrets.load' },
            }),
        );
        logger.error(e);

        yield put(loadSecretsFailure(e));
    }
}
